import React, { Component } from 'react';
import CargomaticCard from 'components/v2/card';
import DataPoller from 'components/ui/DataPoller';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';
import { withTranslation } from 'react-i18next';
const POLLING_FREQ = 15000;
class RecentActivity extends Component {
    constructor(props) {
        super(props);
        this.getRecentActivity = async () => {
            const { email } = this.props;
            const audits = await CustomersAPIUtils.getRecentActivityByEmail(email);
            if (audits && audits.length)
                this.setState({ audits });
        };
        this.state = {
            audits: [],
        };
    }
    componentDidMount() {
        this.getRecentActivity();
    }
    render() {
        const { audits } = this.state;
        const hasAudits = audits && audits.lenght;
        const { t } = this.props;
        return (React.createElement(CargomaticCard, { header: () => React.createElement("h3", null, t('RECENT_ACTIVITY')) },
            React.createElement(DataPoller, { action: this.getRecentActivity, frequency: POLLING_FREQ }),
            hasAudits && (React.createElement("div", { className: "card--no-x-padding card--no-top-padding" },
                React.createElement(AuditHistory, { audits: audits, paginate: true }))),
            !hasAudits && (React.createElement("span", { className: "text-grey-dark" }, t('NO_RECENT_ACTIVITY')))));
    }
}
export default withTranslation()(RecentActivity);
